import { render } from "./TagPopPanel.vue?vue&type=template&id=7538f522&scoped=true"
import script from "./TagPopPanel.vue?vue&type=script&lang=js"
export * from "./TagPopPanel.vue?vue&type=script&lang=js"

import "./TagPopPanel.vue?vue&type=style&index=0&id=7538f522&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7538f522"]])

export default __exports__